<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">Minimum stock Levels</div>
        <div class="section-subTitle my-2">
          List of all stock below minimum stock level
        </div>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-12 col-md-3 mb-2">
          <div class="dropdown-curve-container">
            <label :class="cinema_id ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <multiselect
              :options="Cinemas"
              v-model="selectedCinema"
              :searchable="true"
              placeholder=""
              label="cine_name"
              track-by="cine_id"
              @select="onSelectCinema($event)"
              :allowEmpty="false"
            >
            </multiselect>
          </div>
        </div>
        <div class="col-md-3 mb-4">
          <div class>
            <multiselect
              v-model="selected_category"
              :options="ms_raw_material_categories"
              label="rmc_category"
              track-by="rmc_id"
              @select="onSelectCategory($event, 'select')"
              @remove="onSelectCategory($event, 'remove')"
              :placeholder="$t('Select Category')"
            ></multiselect>
          </div>
        </div>
        <div class="col-md-2 mb-3">
          <button class="btn-blue" @click.prevent.stop="getMinimumStockLogs()">
            {{ $t("Fetch") }}
          </button>
        </div>
        <div
          v-if="rawMaterialsList && rawMaterialsList.length > 0"
          class="col-4 align-self-center d-flex justify-content-end mt-2 mb-2"
        >
          <a target="_blank" title="Download as Excel" @click="excelDownload()">
            Download
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>

      <div class="swc-report mt-3">
        <table class="swc-report-table border" border="1">
          <thead>
            <tr class="lightBluebg">
              <th>Raw Materials Code</th>
              <th>Raw Materials</th>
              <th>Minimum Threshold</th>
              <th>Current Stock</th>
              <th>UOM</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rmObj, rmIndex) in rawMaterialsList" :key="rmIndex">
              <td class="text-left">{{ rmObj["rm_code"] }}</td>
              <td class="text-left">{{ rmObj["rm_name"] }}</td>
              <td class="text-right">
                {{ rmObj["stock_alert_quantity_threshold"] }}
              </td>
              <td class="text-right">
                {{
                  parseFloat(rmObj["current_store_quantity"]).toFixed(
                    MIN_FRACTION_DIGITS
                  )
                }}
              </td>
              <td class="text-left">{{ rmObj["uom_unit"] }}</td>
            </tr>
            <tr v-if="rawMaterialsList.length == 0">
              <td colspan="5">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import _ from "lodash";
import xlsx from "json-as-xlsx";
import NoRecords from "@/components/Partials/NoRecords.vue";
export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      rawMaterialsList: [],
      ms_raw_material_categories: [],
      selected_category: "",
      category_id: null,
      cinema_id: null,
      rm_id: null,
      searchValue: null,
      isRoleID: true,
      Cinemas: [],
      selectedCinema: "",
      excelFile: "",
      pdfFile: "",
    };
  },
  computed: {},

  beforeMount() {
    if (!this.$can("read", "Minimum Stock Logs")) {
      this.$router.go(-1);
    }
    let obj = this.secureStore.get("USINFO").cinema_id;
    if (obj) {
      this.getCinemas(obj);
    } else {
      this.getCinemas();
    }
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.getCinemas(CinemaObj.cine_id);
      this.selectedCinema = CinemaObj;
      this.cinema_id = CinemaObj.cine_id;
    }
    this.getRawMaterialCategories();
  },
  methods: {
    excelDownload() {
      let data = [
        {
          sheet: "Minimum Stocks Logs",
          columns: [
            {
              value: "rm_code",
              label: "Raw Materials Code",
            },
            {
              value: "rm_name",
              label: "Raw Materials",
            },
            {
              value: "stock_alert_quantity_threshold",
              label: "Minimum Threshold",
            },
            {
              value: "current_store_quantity",
              label: "Current Stock",
            },
            {
              value: "uom_unit",
              label: "UOM",
            },
          ],
          content: this.rawMaterialsList,
        },
      ];
      let settings = {
        fileName: `MinimumStockLogs${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    onSelectCategory(event, type = "select") {
      if (type == "select") {
        this.category_id = event["rmc_id"];
        this.selected_category = event;
      } else {
        this.category_id = event["rmc_id"];
        this.selected_category = event;
      }
    },
    getRawMaterialCategories: function () {
      this.ms_raw_material_categories = [];
      let payload = {
        limit: 10000,
        currentPage: 1,
        searchValue: null,
        searchKey: "rmc_category",
        filter_is_active: "Y",
      };
      PosFnbService.GetRawMaterialCategories(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_raw_material_categories = data.Records;
          } else {
            this.$toasted.show("No Records Found");
          }
        })
        .catch(this._CatchError); //message
    },
    getCinemas: function (cine_id) {
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onSelectCinema(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectCinema: function (params) {
      this.selectedCinema = params;
      this.cinema_id = params.cine_id;
      this.$store.dispatch("selectDropdownCinema", params);
      this.getMinimumStockLogs();
    },
    getMinimumStockLogs() {
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.cinema_id,
        searchValue: this.searchValue,
        rm_id: this.rm_id,
        category_id: this.category_id,
      };
      PosFnbService.GetMinimumStockLogs(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.rawMaterialsList = data.Records;
          } else {
            this.rawMaterialsList = [];
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Error: ", err);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>

<style>
.stockUOM-dropdowm .multiselect__content-wrapper {
  width: 160px !important;
}

.reason_multiselect .multiselect__content-wrapper {
  width: 200px !important;
}

.table-wrapper .list-view-table {
  /* width: auto!important; */
  table-layout: auto;
  /* white-space: nowrap; */
}

.table-wrapper .list-view-table th {
  padding: 5px 10px 5px 10px;
}

.bg-red {
  color: red;
  background-color: transparent !important;
}

.bg-green {
  color: green;
}

.bg-transparent {
  background-color: transparent !important;
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/StockComponents/minimumStockLogs.vue